import { cn } from "@/lib/utils";

type Tier = "alpha" | "beta" | "disabled";
type BadgeSize = "xs" | "sm" | "md";

interface TierBadgeProps {
  tier: Tier;
  /** Override the default label (Alpha / Beta / Bald) */
  label?: string;
  size?: BadgeSize;
  className?: string;
}

const TIER_STYLES: Record<Tier, string> = {
  alpha: "bg-chart-5/15 text-[hsl(0,70%,72%)]",
  beta: "bg-chart-2/15 text-[hsl(280,70%,75%)]",
  disabled: "bg-muted text-muted-foreground",
};

const TIER_LABELS: Record<Tier, string> = {
  alpha: "Alpha",
  beta: "Beta",
  disabled: "Bald",
};

const SIZE_STYLES: Record<BadgeSize, string> = {
  xs: "text-[8px] px-1 py-px",
  sm: "text-[10px] px-1.5 py-0.5",
  md: "text-xs px-2 py-0.5",
};

const TierBadge = ({ tier, label, size = "sm", className }: TierBadgeProps) => {
  return (
    <span
      className={cn(
        "inline-flex items-center font-semibold leading-none shrink-0 rounded-md",
        TIER_STYLES[tier],
        SIZE_STYLES[size],
        className,
      )}
    >
      {label ?? TIER_LABELS[tier]}
    </span>
  );
};

export { TierBadge, type Tier, type BadgeSize };
